<template>
  <div>
    <div>
      <search-nav @handleSearch="handleSearch" class="mb-8">
        <search-nav-year-month class="mr-4" label="대상기간" v-model="date" :useAllYear="false" monthType="half" @input="handleSearch" />
        <search-nav-item-select v-if="isShow" label="분야명" v-model="selectProjectId" :list="projList" class="ml-4" />
        <div class="flex items-center">
          <div class="label-text mr-4">{{ getFieldName }}</div>
<!--          <ml-input v-model="selectGroup" class="w-full flex-1" />-->
          <vs-select v-model="selectedFieldName" class="w-full flex-1">
            <vs-select-item value="" text="전체" />
            <vs-select-item :key="index" :value="item" :text="item" v-for="(item, index) in fieldNameOptions" />
          </vs-select>
        </div>
      </search-nav>
    </div>

    <table style="margin-bottom: 60px">
      <thead>
        <tr>
          <td rowspan="2">{{ getFieldName }}</td>
          <td rowspan="2">대상기간(월)</td>
          <td :colspan="keys.length">안전교육현황</td>
        </tr>
        <tr>
          <td v-for="key in keys" :key="`header_${key}`">{{ key }}</td>
        </tr>
      </thead>
      <tbody>
      <template v-if="loading">
        <tr>
          <td :colspan="keys.length + 2">데이터를 불러오는 중입니다.</td>
        </tr>
      </template>
      <template v-else-if="visibleList && visibleList.length > 0">
        <tr v-for="item in visibleList" :key="item.field">
          <td>{{ item.field_name }}</td>
          <td>{{ item.month }}</td>
          <td v-for="key in keys" :key="`content_${key}`">{{ item.data[key] || 0 }}</td>
        </tr>
      </template>
      <template v-else>
        <tr>
          <td :colspan="keys.length + 2">데이터가 없습니다.</td>
        </tr>
      </template>
      </tbody>
    </table>
  </div>
</template>

<script>
import SearchNav from "@/components/nav/SearchNav";
import SearchNavYearMonth from "@/components/nav/SearchNavYearMonth.vue";
import SearchNavItemSelect from "@/components/nav/SearchNavItemSelect";
import moment from "moment";
export default {
  components: {
    SearchNav,
    SearchNavYearMonth,
    SearchNavItemSelect,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  computed: {
    projectId() {
      return this.$route.params.proj_id;
    },
    getFieldName() {
      if (`${this.projectId}` === "2") {
        return "부서명(실과소)";
      } else if (`${this.projectId}` === "3") {
        return "사업명";
      }
      return "사업장명";
    },
    isShow() {
      if (this.projectId > 1) {
        return false;
      }
      return true;
    },
    visibleList() {
      const filterByFieldName = this.form.list.filter((item) => {
        if (this.selectedFieldName === "") {
          return true;
        }
        return item.field_name === this.selectedFieldName;
      });

      // this.date.half 기준에 따라서 필터링
      return filterByFieldName.filter((item) => {
        if (this.date.half === "상반기") {
          return item.month <= 6;
        } else if (this.date.half === "하반기") {
          return item.month > 6;
        }
        return true;
      });
    }
  },
  data() {
    return {
      projList: [
        // {text: '총괄관리', value: 1},
        { text: "중대산업재해(내부종사자) 분야", value: 2 },
        { text: "도급·용역·위탁사업 분야", value: 3 },
        { text: "발주사업 분야", value: 4 },
        { text: "중대시민재해(시설물관리) 분야", value: 5 },
      ],
      keys: ["정기안전교육", "특별안전보건교육", "채용시 안전교육", "작업내용 변경시 안전교육", "안전보건총괄책임자 교육", "안전보건관리책임자 교육", "관리감독자 안전교육", "MSDS", "기타"],
      date: { year: new Date().getFullYear(), month: "", half: "" },
      selectProjectId: 1,
      selectGroup: "",
      selectedFieldName: "",
      searchedYear: 0,
      loading: false,

      // "부서명(실과소)" 선택 옵션
      fieldNameOptions: [],

      form: {
        list: [],
      },
    };
  },
  mounted() {
    this.selectProjectId = this.projectId;
    this.loadGraph();
  },
  methods: {
    handleSearch() {
      this.loadGraph();
    },

    //안전보건교육_현장별교육구분
    async loadGraph() {
      // 같은 년도는 검색하지 않는다
      if (this.searchedYear === this.date.year) {
        return;
      }
      this.loading = true;
      this.searchedYear = this.date.year;

      const summaryKey = ["안전보건교육_현장별교육구분", "count"];

      // 상반기, 하반기 필터링은 클라이언트에서 수행하므로, 전체 기간을 검색한다
      const beginMMDD = "01-01";
      const endMMDD = "12-31";
      // const beginMMDD = this.date.half === "하반기" ? "07-01" : "01-01";
      // const endMMDD = this.date.half === "상반기" ? "06-30" : "12-31";

      const beginAt = this.date.year ? `${this.date.year}-${beginMMDD} 00:00:00` : "";
      const endAt = this.date.year ? `${this.date.year}-${endMMDD} 23:59:59` : "";
      const dateField = "content$body.교육기간.시작";

      const beginAt2 = this.date.year ? `${this.date.year}-${beginMMDD} 00:00:00` : "";
      const endAt2 = this.date.year ? `${this.date.year}-${endMMDD} 23:59:59` : "";
      const dateField2 = "content$body.교육기간.종료";

      const value = await this.$store
        .dispatch("summary/FIRA_LOAD_SUMMARY", {
          boardId: `${this.projectId}` === "2" ? 434 : 107,
          projectIds: this.projectId ? [this.projectId] : [],
          beginAt,
          endAt,
          dateField,
          beginAt2,
          endAt2,
          dateField2,
        })
        .then((value) => {
          return this.get사업장별데이터FromEachProject(this.getProjectName(this.selectProjectId), this.date.year, this.date.month, value, summaryKey);
        });


      // 1. field_name으로 정렬
      const sortByFieldName = value.sort((a, b) => {
        if (a.field_name < b.field_name) {
          return -1;
        }
        if (a.field_name > b.field_name) {
          return 1;
        }
        return 0;
      });

      // 1. field_name으로 그룹화
      const groups = sortByFieldName.reduce((acc, curr) => {
        const fieldName = curr.field_name;
        if (!acc[fieldName]) {
          acc[fieldName] = [];
        }
        acc[fieldName].push(curr);
        return acc;
      }, {});

      this.fieldNameOptions = Object.keys(groups);

      // 2. 각 그룹 내에서 month로 정렬하고 모든 그룹을 하나의 배열로 합치기
      this.form.list = Object.values(groups)
        .map(group => {
          return group.sort((a, b) => parseInt(a.month) - parseInt(b.month));
        })
        .flat();

      this.loading = false;
    },

    getProjectName(projId) {
      for (const proj of this.projList) {
        if (Number(`${proj.value}`) === Number(`${projId}`)) {
          return proj.text;
        }
      }
    },

    get사업장별데이터FromEachProject(selectProject, selectYear, selectMonth, value, summaryKey) {
      const 중복체크 = {};
      const data = [];
      const projNames = Object.keys(value.eachProject);
      if (projNames.length > 0) {
        for (const projName of projNames) {
          if (selectProject === projName) {
            const tempData = value.eachProject[projName][summaryKey[0]];
            if (tempData) {
              // field
              const groupKeys = Object.keys(tempData["count"]).map((data) => data.split("_")[0]);
              for (const group of groupKeys) {
                if (this.selectGroup !== "" && !group.includes(this.selectGroup)) {
                  continue;
                }
                // month 추가
                const tempDataKey = Object.keys(tempData);
                for (const date of tempDataKey) {
                  if (date.split("-").length > 1) {
                    const month = date.split("-")[1];
                    let isAdd = false;
                    if (selectMonth) {
                      if (Number(`${selectMonth}`) === Number(`${month}`)) {
                        isAdd = true;
                      }
                    } else {
                      isAdd = true;
                    }
                    if (isAdd) {
                      if (!중복체크[`${projName}|${group}|${month}`]) {
                        중복체크[`${projName}|${group}|${month}`] = 1;
                        const columnKeys = Object.keys(tempData["count"]).map((data) => data.split("_")[1]);
                        const datadata = {};
                        for (const column of columnKeys) {
                          datadata[column] = tempData[`${selectYear}-${month}`][summaryKey[1]][`${group}_${column}`] ? tempData[`${selectYear}-${month}`][summaryKey[1]][`${group}_${column}`] : 0;
                        }

                        data.push({
                          proj_name: projName,
                          field_name: group,
                          month,
                          data: datadata,
                        });
                      }
                    }
                  }
                } //month
              }
            } // field
          }
        }
      } // project
      return data; // 중복제거 : [...new Set(data.map(JSON.stringify))].map(JSON.parse)
    },
  },
};
</script>

<style lang="scss" scoped>
table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  td {
    text-align: center;
    border: 1px solid #cdcdcd;
    padding: 12px 4px;
  }
}
</style>
